{
  "endTime": "Endzeit",
  "startTime": "Startzeit",
  "time": "Uhrzeit"
}
